export default __webpack_public_path__ + "img/Inter-Bold_54851dc.woff2";